// src/pages/Portfolio.jsx
import React, { useEffect, useState } from 'react';
import Navbar from '../components/Navbar';
import '../styles/styles.css';
import Footer from '../components/Footer';
const projects = [
  {
    id: 1,
    title: 'Interfaz de Ventas para Comercio',
    image: '/images/pos1.png',
    description: 'Sistema web de punto de venta para tiendas físicas. Incluye gestión de caja, productos, conciliación bancaria y control de inventario.',
    details: 'Permite manejar ventas en tiempo real, integrar con cajas registradoras, generar reportes y automatizar inventario. Adaptado a dispositivos móviles y con control de roles.',
    role: 'Fullstack Developer',
    tech: 'PHP, JavaScript, MySQL',
    type: 'Colaboración Privada',
  },
  {
    id: 2,
    title: 'Plataforma de Pedidos en Línea',
    image: '/images/mockupedido.png',
    description: 'Web app para recepción y gestión de pedidos. Carrito de compras, entregas y múltiples formas de pago.',
    details: 'Panel de administrador, autenticación de clientes, control de estados, diseño mobile-first. Ideal para comercios locales.',
    role: 'Fullstack Developer',
    tech: 'PHP, JavaScript, MySQL',
    type: 'Colaboración Privada',
  },
  {
    id: 3,
    title: 'App Mobile Corporativa',
    image: '/videos/app.mp4',
    description: 'Aplicación móvil diseñada para una empresa del sector gastronómico, con funcionalidades de pedidos, catálogo digital y perfil de usuario.',
    details: 'Este proyecto fue desarrollado en colaboración con otra empresa aliada. Realicé la lógica backend con PHP y estructuré la comunicación con la app a través de servicios web. La interfaz fue adaptada con una plantilla representativa para resguardar la identidad de la marca. Fue empaquetada y publicada mediante Android Studio, con compatibilidad para Android e iOS.',
    role: 'Backend Developer & Integración Mobile',
    tech: 'PHP, MySQL, Android Studio (Android/iOS)',
    type: 'Colaboración privada',
  }
  ,
  {
    id: 4,
    title: 'Página principal de empresa tecnológica',
    image: '/videos/system.mp4',
    description: 'Sitio web empresarial diseñado para una compañía del sector tecnológico. Presenta sus productos, servicios y valores de marca con enfoque profesional y moderno.',
    details: 'Desarrollada con React, esta interfaz ofrece navegación fluida, secciones dinámicas para destacar servicios, testimonios y productos, así como optimización visual para diferentes dispositivos. El proyecto está representado con mockups para proteger los derechos del cliente.',
    role: 'Frontend Developer',
    tech: 'React, CSS, JavaScript',
    type: 'Cliente Personal',
  },
  
  {
    id: 5,
    title: 'Generador de Códigos QR',
    image: '/images/qr.png',
    description: 'Proyecto personal para crear códigos QR en segundos. Disponible en GitHub.',
    details: 'Colores personalizados, múltiples tipos de datos, descarga en PNG y diseño responsivo.',
    role: 'Fullstack Developer',
    tech: 'JavaScript, HTML, CSS',
    type: 'Personal',
    link: 'https://github.com/Missmuyanna/GENERADOR-DE-QR', // Ejemplo real si está disponible
  },
  {
    id: 6,
    title: 'Interfaz de Gestión Gubernamental',
    image: '/images/gob.png',
    description: 'Diseño de interfaz administrativa con selección de roles, visualización de métricas y gráficos dinámicos. Inspirado en mi experiencia real en el desarrollo de software para entidades gubernamentales.',
    details: 'Diseño de interfaz administrativa con selección de roles, visualización de métricas y gráficos dinámicos. Inspirado en mi experiencia real en el desarrollo de software para entidades gubernamentales.',
    role: 'Frontend & UX',
    tech: 'PHP, JavaScript',
    type: 'Inspirado en trabajo real',
  },
];

function Portfolio() {
  const [selectedProject, setSelectedProject] = useState(null);

  useEffect(() => {
    document.body.classList.add('body-portfolio');
    return () => {
      document.body.classList.remove('body-portfolio');
    };
  }, []);

  return (
    <>
      <Navbar />

      <section className="portfolio-section">
        {/* 🎥 Video de fondo */}
        <video autoPlay loop muted playsInline className="portfolio-video">
          <source src="/videos/portfolio.mp4" type="video/mp4" />
        </video>

        <div className="portfolio-content">
          <h1 className="portfolio-title">Proyectos Destacados</h1>
          <p className="portfolio-description">
            Desarrollo soluciones digitales centradas en usabilidad, escalabilidad y propósito. Aquí una muestra de lo que he construido.
          </p>

          <div className="portfolio-grid">
            {projects.map((project) => (
              <div className="portfolio-card" key={project.id} onClick={() => setSelectedProject(project)}>
                {project.id === 3 || project.id === 4 ? (

  <video
    autoPlay
    loop
    muted
    playsInline
    className="portfolio-image"
  >
    <source src={project.image} type="video/mp4" />
  </video>
) : (
  <img src={project.image} alt={project.title} className="portfolio-image" />
)}

                <h3 className="portfolio-card-title">{project.title}</h3>
                <p className="portfolio-card-description">{project.description}</p>
                <span className="portfolio-tag">{project.type}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Modal */}
      {selectedProject && (
        <div className="portfolio-modal-overlay" onClick={() => setSelectedProject(null)}>
          <div className="portfolio-modal" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setSelectedProject(null)}>×</button>
            {selectedProject.id === 3 || selectedProject.id === 4 ? (

  <video
    autoPlay
    loop
    muted
    playsInline
    className="modal-image"
  >
    <source src={selectedProject.image} type="video/mp4" />
    Tu navegador no soporta video HTML5.
  </video>
) : (
  <img src={selectedProject.image} alt={selectedProject.title} className="modal-image" />
)}

            <h2>{selectedProject.title}</h2>
            <p className="modal-role"><strong>Rol:</strong> {selectedProject.role}</p>
            <p className="modal-tech"><strong>Tecnologías:</strong> {selectedProject.tech}</p>
            <p className="modal-description">{selectedProject.details}</p>
            {selectedProject.link && (
              <a href={selectedProject.link} target="_blank" rel="noopener noreferrer" className="modal-link">
                Ver en GitHub →
              </a>
            )}
          </div>
        </div>
        
      )}
      
    </>
    
  );
  
}

export default Portfolio;
